<!-- ╔══════════════════════════════════════════════════════════╗ -->
<!-- ║  DOT Leads™  ·  Top Navigation Bar                      ║ -->
<!-- ╚══════════════════════════════════════════════════════════╝ -->

<nav class="top-nav" *ngIf="is_top_menu_visible">
  <!-- ── Left: Logo ── -->
  <div class="nav-left">
    <a class="nav-logo-wrap" routerLink="/search/index">
      <img
        src="/../bundles_updated/browser/assets/logo-tagline.png"
        alt="DOT Leads Logo"
        class="nav-logo"
      />
    </a>
    <div class="nav-logo-sep"></div>
  </div>

  <!-- ── Center: Nav links ── -->
  <div class="nav-center">
    <a
      class="nav-link"
      routerLink="/search/index"
      routerLinkActive="nav-link--active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="pi pi-search nav-link-icon"></i> Search
    </a>
    <a
      class="nav-link"
      routerLink="/result/index"
      routerLinkActive="nav-link--active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="pi pi-table nav-link-icon"></i> Results
    </a>
    <a
      class="nav-link"
      routerLink="/account/index"
      routerLinkActive="nav-link--active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="pi pi-user nav-link-icon"></i> My Account
    </a>
    <a class="nav-link" routerLink="/help" routerLinkActive="nav-link--active">
      <i class="pi pi-question-circle nav-link-icon"></i> Help
    </a>
  </div>

  <!-- ── Right: User + Logout ── -->
  <div class="nav-right">
    <!-- Avatar-only user button -->
    <div class="nav-user" *ngIf="user">
      <div *ngIf="user.IDUser == 17">
        <a
          class="nav-link"
          routerLink="/admin/index"
          routerLinkActive="nav-link--active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="pi pi-user nav-link-icon"></i> Administration
        </a>
      </div>
      <button
        class="nav-avatar-btn"
        (click)="openWarningsDrawer()"
        [class.nav-avatar-btn--warn]="warnings().length > 0"
        [title]="user.User1"
      >
        <span class="nav-avatar-letter">{{
          user.User1 | slice: 0 : 2 | uppercase
        }}</span>
        <span class="nav-avatar-ring" *ngIf="warnings().length > 0"></span>
        <span
          class="nav-avatar-ring nav-avatar-ring--delay"
          *ngIf="warnings().length > 0"
        ></span>
      </button>

      <button
        class="nav-warn-dot"
        *ngIf="warnings().length > 0"
        [title]="
          warnings().length + ' warning' + (warnings().length > 1 ? 's' : '')
        "
      >
        {{ warnings().length }}
      </button>
    </div>

    <div class="nav-right-sep"></div>

    <button class="logout-btn" (click)="logout()">
      <i class="pi pi-sign-out"></i>
      Logout
    </button>
  </div>
</nav>

<!-- ══════════════════════════════════════════
     WARNINGS DRAWER (right slide-in)
══════════════════════════════════════════ -->

<!-- Backdrop -->
<div
  class="drawer-backdrop"
  [class.drawer-backdrop--visible]="warningsDrawerOpen"
  (click)="closeWarningsDrawer()"
></div>

<!-- Drawer panel -->
<div class="warnings-drawer" [class.warnings-drawer--open]="warningsDrawerOpen">
  <!-- Header: User profile -->
  <div class="wd-header">
    <button class="wd-close" (click)="closeWarningsDrawer()">
      <i class="pi pi-times"></i>
    </button>
    <div class="wd-user">
      <div class="wd-user-avatar">
        {{ user?.User1 | slice: 0 : 1 | uppercase }}
      </div>
      <div class="wd-user-info">
        <span class="wd-user-name"
          >{{ user?.FirstName }} {{ user?.LastName }}</span
        >
        <span class="wd-user-username">{{ user?.User1 }}</span>
      </div>
    </div>
    <div class="wd-warning-summary" *ngIf="warnings().length > 0">
      <div class="wd-warning-summary-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <div>
        <span class="wd-warning-summary-count"
          >{{ warnings().length }} warning{{
            warnings().length !== 1 ? "s" : ""
          }}</span
        >
        <span class="wd-warning-summary-sub">require your attention</span>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div class="wd-loading" *ngIf="warningsLoading">
    <div class="wd-shimmer" *ngFor="let i of [1, 2, 3]"></div>
  </div>

  <!-- Empty state -->
  <div class="wd-empty" *ngIf="!warningsLoading && warnings().length === 0">
    <i class="pi pi-check-circle"></i>
    <strong>All clear!</strong>
    <p>No warnings at this time.</p>
  </div>

  <!-- Warning list -->
  <div class="wd-list" *ngIf="!warningsLoading && warnings().length > 0">
    <div
      class="wd-item"
      *ngFor="let w of warnings(); let i = index"
      [class.wd-item--error]="w.Severity == '1'"
      [class.wd-item--warning]="w.Severity == '2'"
      [class.wd-item--info]="w.Severity == '3'"
      [style.animation-delay]="i * 0.06 + 's'"
    >
      <div class="wd-item-icon">
        <i
          class="pi"
          [class.pi-times-circle]="w.Severity == '1'"
          [class.pi-exclamation-triangle]="w.Severity == '2'"
          [class.pi-info-circle]="w.Severity == '3'"
        ></i>
      </div>
      <div class="wd-item-body">
        <span class="wd-item-title">{{ w.Title }}</span>
        <span class="wd-item-message" *ngIf="w.Message">{{ w.Message }}</span>
        <span class="wd-item-date" *ngIf="w.Date">{{
          w.Date | date: "mediumDate"
        }}</span>
      </div>
      <!-- Optional action button -->
      <button
        class="wd-item-action"
        *ngIf="w.ActionType"
        (click)="handleWarningAction(w)"
      >
        {{ w.ActionType == "1" || w.ActionType == "0" ? "Configure SMTP" : "" }}
        <i class="pi pi-arrow-right"></i>
      </button>
    </div>
  </div>

  <!-- Footer -->
  <div class="wd-footer" *ngIf="!warningsLoading && warnings().length > 0">
    <button class="wd-dismiss-btn" (click)="closeWarningsDrawer()">
      <i class="pi pi-check"></i> Dismiss
    </button>
  </div>
</div>

<p-dialog
  [(visible)]="emailConfigVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [showHeader]="false"
  [contentStyle]="{ padding: '0', borderRadius: '12px', overflow: 'hidden' }"
  [style]="{ width: 'auto', borderRadius: '12px' }"
  styleClass="email-config-dialog"
>
  <app-email-config (closed)="emailConfigVisible = false"></app-email-config>
</p-dialog>

<!-- ── Loader & router ── -->
<app-loader [is_visible]="loading"></app-loader>
<script
  src="https://cdn.tiny.cloud/1/xmmwap6k4ny50skhxvygk87qne95vevpu6032c5kbo76j4ug/tinymce/6/tinymce.min.js"
  referrerpolicy="origin"
></script>
<router-outlet />
<!-- ── Migration Banner ───────────────────────────────────────────────────── -->

<p-dialog
  [(visible)]="showMigrationDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [position]="'top'"
  [showHeader]="false"
  [contentStyle]="{ padding: '24px', borderRadius: '16px', overflow: 'hidden' }"
  [style]="{ width: '420px', maxWidth: '95vw', borderRadius: '16px' }"
  styleClass="migration-dialog"
>
  <div class="mgd">
    <!-- ── Header ── -->
    <div class="mgd-head">
      <div class="mgd-deco mgd-deco--1"></div>
      <div class="mgd-deco mgd-deco--2"></div>

      <button class="mgd-close" (click)="showMigrationDialog = false">
        <i class="pi pi-times"></i>
      </button>

      <div class="mgd-head-inner">
        <div class="mgd-badge">
          <i class="pi pi-exclamation-triangle"></i>
          Action Required
        </div>
        <h2 class="mgd-title">Upgrade Your Email</h2>
        <p class="mgd-sub">
          Switch to OAuth for a faster, safer connection — no passwords needed.
        </p>
      </div>
    </div>

    <!-- ── Body ── -->
    <div class="mgd-body">
      <!-- Benefits -->
      <div class="mgd-benefits">
        <div class="mgd-benefit">
          <div class="mgd-benefit-ico mgd-benefit-ico--green">
            <i class="pi pi-lock"></i>
          </div>
          <div>
            <p class="mgd-benefit-title">No passwords stored</p>
            <p class="mgd-benefit-sub">Secured with OAuth 2.0 tokens</p>
          </div>
        </div>
        <div class="mgd-benefit">
          <div class="mgd-benefit-ico mgd-benefit-ico--blue">
            <i class="pi pi-refresh"></i>
          </div>
          <div>
            <p class="mgd-benefit-title">Auto-renewing access</p>
            <p class="mgd-benefit-sub">Tokens refresh automatically</p>
          </div>
        </div>
        <div class="mgd-benefit">
          <div class="mgd-benefit-ico mgd-benefit-ico--purple">
            <i class="pi pi-bolt"></i>
          </div>
          <div>
            <p class="mgd-benefit-title">One-click setup</p>
            <p class="mgd-benefit-sub">Connect in under 30 seconds</p>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="mgd-divider"></div>

      <!-- Steps -->
      <div class="mgd-steps">
        <div class="mgd-step">
          <div class="mgd-step-num">1</div>
          <div class="mgd-step-connector"></div>
          <div class="mgd-step-body">
            <span class="mgd-step-title">Open Email Settings</span>
            <span class="mgd-step-sub">Click the button below</span>
          </div>
        </div>
        <div class="mgd-step">
          <div class="mgd-step-num">2</div>
          <div class="mgd-step-connector"></div>
          <div class="mgd-step-body">
            <span class="mgd-step-title">Pick Gmail or Outlook</span>
            <span class="mgd-step-sub">Choose your provider</span>
          </div>
        </div>
        <div class="mgd-step">
          <div class="mgd-step-num">3</div>
          <div class="mgd-step-connector mgd-step-connector--hidden"></div>
          <div class="mgd-step-body">
            <span class="mgd-step-title">Sign in &amp; connect</span>
            <span class="mgd-step-sub">Done!</span>
          </div>
        </div>
      </div>

      <!-- Providers -->
      <div class="mgd-providers">
        <div class="mgd-provider-chip">
          <svg width="13" height="13" viewBox="0 0 48 48">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          Gmail
        </div>
        <div class="mgd-provider-chip">
          <svg width="13" height="13" viewBox="0 0 23 23">
            <path fill="#f3f3f3" d="M0 0h23v23H0z" />
            <path fill="#f35325" d="M1 1h10v10H1z" />
            <path fill="#81bc06" d="M12 1h10v10H12z" />
            <path fill="#05a6f0" d="M1 12h10v10H1z" />
            <path fill="#ffba08" d="M12 12h10v10H12z" />
          </svg>
          Outlook
        </div>
        <div class="mgd-provider-chip">
          <i class="pi pi-send" style="font-size: 10px; color: #ff5733"></i>
          Mailjet
        </div>
      </div>
    </div>

    <!-- ── Footer ── -->
    <div class="mgd-footer">
      <button class="mgd-btn-ghost" (click)="showMigrationDialog = false">
        Later
      </button>
      <button class="mgd-btn-primary" (click)="openEmailSettings()">
        <i class="pi pi-envelope"></i>
        Open Email Settings
      </button>
    </div>
  </div>
</p-dialog>

<!-- ── Notification Dialog ────────────────────────────────────────────────── -->

<p-dialog
  [(visible)]="showNotificationDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [showHeader]="false"
  [contentStyle]="{ padding: '0', borderRadius: '14px', overflow: 'hidden' }"
  [style]="{ width: '480px', maxWidth: '95vw', borderRadius: '14px' }"
  styleClass="notification-dialog"
  (onHide)="closeNotificationDialog()"
>
  <div class="ntf" *ngIf="notificationWarning as n">
    <button class="ntf-close" (click)="closeNotificationDialog()">
      <i class="pi pi-times"></i>
    </button>

    <div class="ntf-head">
      <div class="ntf-icon">
        <i class="pi pi-bell"></i>
      </div>
      <h2 class="ntf-title">{{ n.Title }}</h2>
    </div>

    <div class="ntf-body" [innerHTML]="n.Message"></div>

    <div class="ntf-footer">
      <button class="ntf-btn-primary" (click)="closeNotificationDialog()">
        Close
      </button>
    </div>
  </div>
</p-dialog>
